export const REPRESENTATIVE_FRAME_WIDTH_PX = 384;
export const TOOL_CALL_FRAME_WIDTH_PX = 512;
const DEFAULT_QUALITY = 0.7;

export function encodeFrame(
    source: HTMLCanvasElement,
    maxWidthPx: number = REPRESENTATIVE_FRAME_WIDTH_PX,
    quality: number = DEFAULT_QUALITY,
): string {
    if (source.width <= maxWidthPx) {
        return source.toDataURL('image/jpeg', quality);
    }
    const scale = maxWidthPx / source.width;
    const target = document.createElement('canvas');
    target.width = maxWidthPx;
    target.height = Math.round(source.height * scale);
    const ctx = target.getContext('2d');
    if (!ctx) throw new Error('Could not acquire 2D context for frame encoding');
    ctx.drawImage(source, 0, 0, target.width, target.height);
    return target.toDataURL('image/jpeg', quality);
}
